/*  MUI  */
import { Grid } from '@mui/material';

/*  Shared  */
import { Percentage, Sum } from 'application/Shared/Components/Cards';
import { DataAPIVisualsPieChart } from 'application/Shared/Components/DataAPIVisualsCard';
import { NoteTypes, NoteTypesValues } from 'application/Shared/Constants';
import { Helpers } from 'application/Shared/Helpers';
import { Note } from 'application/Shared/Requests';

/*  React  */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'router/withRouter';

/*  State  */
const state = () => ({
    communityNotes: [],
    loaded: false,
    notes: [],
    totalActive: 0,
    typeTotals: []
});

class Cards extends Component {
    constructor(props) {
        super(props);
        this.state = state();

        const clientId = props?.match?.params?.clientId;
        /* requests */
        this.Note = new Note(clientId);
    }

    componentDidMount() {
        this.load();
    }

    componentDidUpdate() {
        const { reload } = this.props;
        if (reload) {
            this.reload();
        }
    }

    componentWillUnmount() {
        this.unmounted = true;
        this.Note.cancel();
    }

    load = async () => {
        await this.loadClientData();

        if (this.unmounted) return;
        await this.loadCommunityData();

        if (this.unmounted) return;
        this.setState({ loaded: true });
    };

    loadClientData = async () => {
        const { params, t } = this.props;

        const notes = await this.Note.getAll(params);
        if (!notes) {
            if (this.unmounted) return;
            this.setState({ loaded: true });
            return;
        }

        const typeTotals = {};
        NoteTypesValues.forEach((t) => {
            typeTotals[t] = 0;
        });

        const activeNotes = notes.filter((n) => !n.completed);
        const totalActive = Helpers.count(activeNotes);

        activeNotes.forEach((n) => {
            const { type } = n;
            if (Helpers.isset(typeTotals, NoteTypes[type])) {
                typeTotals[NoteTypes[type]] += 1;
            }
        });

        if (this.unmounted) return;

        const pieFormattedtypeTotals = [];
        Object.entries(typeTotals).forEach(([name, value]) => {
            pieFormattedtypeTotals.push({ name: t(`Notes.${name}`), value });
        });

        this.setState({
            notes,
            totalActive,
            typeTotals: pieFormattedtypeTotals
        });
    };

    loadCommunityData = async () => {
        const { params } = this.props;

        const payload = { approved: true, includeImported: true };
        if (Helpers.isset(params, 'applicationId')) {
            payload.applicationId = params.applicationId;
        }

        const communityNotes = await this.Note.getCommunity(payload);

        if (this.unmounted) return;
        this.setState({ communityNotes });
    };

    reload = () => {
        if (this.unmounted) return;
        this.setState(state(), () => this.load());
    };

    render() {
        const { t, report } = this.props;
        const { loaded, notes, totalActive, typeTotals, communityNotes } =
            this.state;

        const xs = report ? 4 : 12;
        const sm = report ? 4 : 6;
        const lg = report ? 4 : 3;

        return (
            <Grid container spacing={3}>
                <Grid item xs={xs} sm={sm} lg={lg}>
                    <Sum
                        title={t('Notes.total_active')}
                        sum={totalActive}
                        loading={!loaded}
                    />
                </Grid>
                <Grid item xs={xs} sm={sm} lg={lg}>
                    <DataAPIVisualsPieChart
                        title={t('Notes.type_breakdown')}
                        card
                        data={typeTotals}
                    />
                </Grid>
                <Grid item xs={xs} sm={sm} lg={lg}>
                    <Percentage
                        accessorKey="completed"
                        data={notes}
                        loading={!loaded}
                        title="Completed Notes"
                    />
                </Grid>
                {!report && (
                    <Grid item xs={xs} sm={sm} lg={lg}>
                        <Percentage
                            accessorKey="imported"
                            data={communityNotes}
                            loading={!loaded}
                            title={t('Notes.community_imported')}
                        />
                    </Grid>
                )}
            </Grid>
        );
    }
}

export default withRouter(withTranslation()(Cards));
